@let userLookup =
  usersEc.plugins.cachePlugin.feature.selectors.lookup.asSignal();
@let recordHistory = recordHistorySg();

<atn-ds-widget title="History">
  <i
    actions
    class="atn-icon atn-close atn-red"
    (click)="close.emit()"
  ></i>

  <div class="atn-record-history-log__body">
    <table class="atn-record-history-log__table">
      <thead class="atn-record-history-log__table-header">
        <tr class="atn-record-history-log__table-row">
          <th class="atn-record-history-log__table-cell">Action</th>
          <th class="atn-record-history-log__table-cell">Modified</th>
          <th class="atn-record-history-log__table-cell">By</th>
        </tr>
      </thead>
      <!-- TODO: Add loading state -->
      <tbody>
        @for (log of recordHistory; track $index) {
          <tr class="atn-record-history-log__table-row">
            <td class="atn-record-history-log__table-cell">
              <atn-ds-tag [text]="log.action" />
            </td>
            <td class="atn-record-history-log__table-cell">
              {{ log.timestamp | date: 'MM/dd/yyyy @ HH:mm' }}
            </td>
            <td class="atn-record-history-log__table-cell">
              {{ userLookup[log.userId]?.name ?? 'Unknown User' }}
            </td>
          </tr>
        } @empty {
          <tr>
            <td
              colspan="3"
              class="atn-record-history-log__empty-cell"
            >
              <div class="atn-record-history-log__empty-state-container">
                <atn-ds-empty-state
                  type="no-data"
                  title="Nothing to see here!"
                  description="No data was found. Not what you expected? Try refreshing, check your source data, or contact support."
                />
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</atn-ds-widget>
